import moment from 'moment';
import React from 'react';
import styled from 'styled-components';
import DynamicTable from '@atlaskit/dynamic-table';

import { getDeleteBtn, getHeads } from '../../../components/settings/utils';
import { handleNullException } from '../../../services/UtilsService';
import LinkBtn from '../../../shared/buttons/LinkBtn';
import CreatedOrUpdated from '../../../shared/createdOrUpdated/CreatedOrUpdated';
import iPalletSystem from '../../../types/iPalletSystem';

const TableWrapper = styled.div`
  th[data-testid='settings-pallet-table-column-Name--head--cell'] {
    width: 60%;
    min-width: 20rem;
  }

  td:last-child {
    max-width: 2rem;
  }
`;

export const COLUMNS = ['Name', 'Created', 'Updated', 'Operation'];

const PalletListTable = ({
  data,
  onDelete,
  onEdit,
  isLoading,
}: {
  data: Array<iPalletSystem>;
  onDelete: (id: string) => void;
  onEdit: (id: string) => void;
  isLoading: boolean;
}) => {
  const getRows = () => {
    return data
      ?.sort((a, b) => moment(b.createdAt).diff(moment(a.createdAt)))
      .map((item: iPalletSystem) => ({
        cells: [
          {
            key: item.name,
            content: (
              <LinkBtn
                btnName={handleNullException(item, 'name')}
                testId={`pallet-list-linkBtn-${item.id}`}
                onClick={() => onEdit(item.id)}
              />
            ),
          },
          {
            content: (
              <CreatedOrUpdated
                operatedAt={handleNullException(item, 'createdAt')}
                operator={handleNullException(item, 'createdBy.firstName')}
              />
            ),
          },
          {
            content: (
              <CreatedOrUpdated
                operatedAt={handleNullException(item, 'updatedAt')}
                operator={handleNullException(item, 'updatedBy.firstName')}
              />
            ),
          },
          {
            content: getDeleteBtn({
              id: item.id,
              answer: item.name || 'name n/a',
              onClick: onDelete,
            }),
          },
        ],
      }));
  };

  return (
    <TableWrapper>
      <DynamicTable
        head={getHeads(COLUMNS, 'settings-pallet')}
        rows={getRows()}
        testId={'settings-pallet-list-table'}
        isLoading={isLoading}
        rowsPerPage={10}
        defaultPage={1}
      />
    </TableWrapper>
  );
};

export default PalletListTable;
